import { c as _c } from "react/compiler-runtime";
import { Alert } from "@navikt/ds-react";
import type { FetchResultError } from "@/server/tokenXFetch/FetchResult";
import { getFetchResultErrorMessage } from "@/ui-helpers/error-messages";
interface Props {
  /**
   * The error object returned from a server action or fetch.
   * If null, the component renders nothing.
   */
  error: FetchResultError | null;
  /**
   * Optional override for generic errors (e.g. 500, 404).
   * Specific errors (like LEGE_NOT_FOUND) will ignore this and show their specific message.
   */
  fallbackMessage?: string;
  /** Optional CSS class for custom styling. */
  className?: string;
}

/**
 * Standardized error display for backend fetch operations.
 * Automatically resolves the correct user-facing message based on the error type.
 */
export function FetchErrorAlert(t0) {
  const $ = _c(6);
  const {
    error,
    fallbackMessage,
    className
  } = t0;
  if (!error) {
    return null;
  }
  let t1;
  if ($[0] !== error || $[1] !== fallbackMessage) {
    t1 = getFetchResultErrorMessage(error, fallbackMessage);
    $[0] = error;
    $[1] = fallbackMessage;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== className || $[4] !== t1) {
    t2 = <Alert variant="error" className={className}>{t1}</Alert>;
    $[3] = className;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}